import { Box, IconButton } from "@chakra-ui/react";
import PremiumSubscription from "./components/PremiumSubscription";
import PremiumList from "./components/PremiumList";
import { CloseIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";

const Premium = () => {
  const naviate = useNavigate();
  return (
    <Box height={"100vh"} overflowY={"scroll"} position={"relative"}>
      <IconButton
        aria-label="close lesson"
        border={"1px solid white"}
        borderRadius={".9rem"}
        variant={"outline"}
        position={{ base: "relative", lg: "sticky" }}
        left={"1.5rem"}
        top={"1.5rem"}
        size={"md"}
        zIndex={"sticky"}
        onClick={() => naviate(-1)}
        icon={<CloseIcon />}
      ></IconButton>
      <PremiumSubscription />
      <PremiumList />
    </Box>
  );
};
export default Premium;
